import ajax from '../../../components/ajax';
// паузы перед повторными запросами при сетевой ошибке или ошибке сервера
const RETRY_DELAYS = [1000, 3000];
export default function useProductApi(productId) {
    function request(attempt = 0) {
        return ajax(`/api/product/${productId}`, {})
            .then(response => {
            if (response.status >= 500) {
                throw new Error(`Product request failed with status ${response.status}`);
            }
            return response.json();
        })
            .catch(error => {
            if (attempt >= RETRY_DELAYS.length) {
                throw error;
            }
            return new Promise(resolve => setTimeout(resolve, RETRY_DELAYS[attempt]))
                .then(() => request(attempt + 1));
        });
    }
    return { request: () => request() };
}
